import { css } from 'lit';

/**
 * Style wspólne dla komponentów w shadow DOM.
 *
 * Nie zawierają kolorów na sztywno — wyłącznie odwołania do tokenów
 * z styles/tokens.css, które przenikają przez granicę shadow DOM.
 */
export const sharedStyles = css`
  :host {
    box-sizing: border-box;
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  :focus-visible {
    outline: 2px solid var(--qz-accent);
    outline-offset: 2px;
  }

  /* Etykieta metadanych — sygnatura, kategoria, licznik. */
  .label {
    font-family: var(--qz-font-mono);
    font-size: var(--qz-text-xs);
    font-weight: 500;
    letter-spacing: var(--qz-label-tracking);
    text-transform: uppercase;
    color: var(--qz-ink-muted);
  }

  .heading {
    font-family: var(--qz-font-display);
    font-weight: 700;
    line-height: 1.1;
    letter-spacing: -0.02em;
    margin: 0;
  }

  /*
   * Karta katalogowa z wycięciem na pręt u dołu — ten półkolisty otwór,
   * którym w szufladzie przechodzi metalowy pręt. Jedyna ozdoba w systemie
   * i jedyne miejsce, w którym wolno ją stosować.
   */
  .card {
    position: relative;
    background: var(--qz-surface);
    border: 1px solid var(--qz-line);
    border-radius: var(--qz-radius-lg);
    box-shadow: var(--qz-shadow);
  }

  .card::after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: -1px;
    width: 26px;
    height: 13px;
    transform: translateX(-50%);
    background: var(--qz-bg);
    border: 1px solid var(--qz-line);
    border-bottom: none;
    border-radius: 26px 26px 0 0;
  }

  @media (prefers-reduced-motion: reduce) {
    * {
      transition: none !important;
      animation: none !important;
    }
  }
`;
